<section id="SustainableSocialImpactNote" class="ssin-section position-relative overflow-hidden py-5">
    <div class="container py-4">
        <div class="row align-items-center g-5">

        <!-- LEFT: NOTE CARD -->
        <div class="col-12 col-lg-6">
            <div class="ssin-frame rounded-4 p-3 p-md-4">
            <div class="ssin-note rounded-4 p-4 p-md-5 text-center">

                <div class="ssin-note-kicker text-uppercase text-xs fw-semibold mb-4">
                {{ ssin_data.note_kicker }}
                </div>

                <div class="ssin-note-value mb-1">
                {{ ssin_data.note_value }}
                </div>

                <div class="ssin-note-series text-xs mb-4">
                {{ ssin_data.note_series }}
                </div>

                <div class="ssin-badge-wrap d-flex justify-content-center mb-4">
                <div class="ssin-badge d-flex align-items-center justify-content-center">
                    <span class="ssin-badge-icon">★</span>
                </div>
                </div>

                <div class="ssin-divider my-4"></div>

                <div class="ssin-note-footer text-uppercase text-xs">
                {{ ssin_data.note_footer }}
                </div>

            </div>
            </div>
        </div>

        <!-- RIGHT: CONTENT -->
        <div class="col-12 col-lg-6">
            <div class="d-flex align-items-center gap-3 text-uppercase text-xs fw-semibold ssin-kicker mb-3">
            <span class="ssin-kicker-line"></span>
            <span>{{ ssin_data.kicker }}</span>
            </div>

            <h2 class="ssin-title mb-3">
            {{ ssin_data.title }}
            </h2>

            <p class="ssin-lead mb-4">
            {{ ssin_data.description }}
            </p>

            <div class="d-flex flex-column gap-4">
            <div
                v-for="item in ssin_features"
                :key="item.key"
                class="d-flex gap-3 align-items-start"
            >
                <div class="ssin-icon-box d-flex align-items-center justify-content-center" :class="item.icon_box_class">
                <span class="ssin-icon">{{ item.icon }}</span>
                </div>

                <div>
                <div class="ssin-feature-title mb-1">
                    {{ item.title }}
                </div>
                <div class="ssin-feature-text">
                    {{ item.text }}
                </div>
                </div>
            </div>
            </div>

        </div>

        </div>
    </div>
</section>
